// T3-B sponsored motif (PR 4, 2026-05-07): sponsored_motifs CRUD endpoints HTTP client.
// api 側 implementation: omikuji-api PR #97。motif は親 campaign 配下で list / create。
//
// auth: ADMIN only。

import ApiService from './ApiService';

export default class SponsoredMotifApi extends ApiService {
    // GET /system/sponsored-campaigns/:campaignId/motifs
    listByCampaign(campaignId: string | number) {
        return this.get(`sponsored-campaigns/${campaignId}/motifs`);
    }

    getById(id: string | number) {
        return this.get(`sponsored-motifs/${id}`);
    }

    // POST /system/sponsored-campaigns/:campaignId/motifs
    create(payload: { campaignId: string | number, data: any }) {
        const { campaignId, data } = payload;
        return this.post(`sponsored-campaigns/${campaignId}/motifs`, data);
    }

    update(payload: { id: string | number, data: any }) {
        const { id, data } = payload;
        return this.put(`sponsored-motifs/${id}`, data);
    }

    remove(id: string | number) {
        return this.delete(`sponsored-motifs/${id}`);
    }
}
